import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, ValidatorFn, Validators } from '@angular/forms';
//import { StepperOrientation } from '@angular/material/stepper';
//import { map, Observable } from 'rxjs';
import {BreakpointObserver} from '@angular/cdk/layout';
import { HomeService } from '../service/home.service';
import { formatDataForDropDown } from '../utils/helpers';
//import { ErrorStateMatcher } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { AlertService } from '../service/alert.service';
import { TermsConditionComponent } from '../terms-condition/terms-condition.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import * as moment from 'moment';
import { ItemStartdatePopupComponent } from '../item-startdate-popup/item-startdate-popup.component';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  // @ts-ignore
  detailForm: FormGroup;
  dropDownValues:any = {};
  LocationName:any;
  itemList:any = [];
  checked:boolean = false;
  itemDetail:any = null;
  TransactionHeadId:any;
  Amount:any;
  minAge: any = 18;
  maxDate;
  minDateError: boolean = false;
  disableSelect: boolean = false;
  //stepperOrientation: Observable<StepperOrientation>;

  genderList = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
  ]

  constructor(private fb: FormBuilder, private ngxService: NgxUiLoaderService, breakpointObserver: BreakpointObserver,private homeService:HomeService,private alertService:AlertService,private datePipe: DatePipe,private router:Router,private aRoute:ActivatedRoute,public dialog: MatDialog){
    // this.stepperOrientation = breakpointObserver
    //   .observe('(min-width: 800px)')
    //   .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));
  }

  ngOnInit():void {
    this.initForm();
    this.GetAllClassesForCommissionInitial();
    this.maxDate = moment().subtract(Number(this.minAge), 'years');
    this.maxDate = moment(this.maxDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    console.log(this.maxDate)
  }
  get form() { return this.detailForm.controls }
  initForm() {
    this.detailForm = this.fb.group({
      FirstName:[null],
      LastName:[null],
      Gender:[null],
      Email:[null, Validators.compose([Validators.required, Validators.email])],
      MobileNo:[null],
      DateOfBirth:[null, Validators.compose([Validators.required])],
      LegalId:[null],
      NationalityId:[null],
      LocationId:[null]
    });
  }
  
  GetAllClassesForCommissionInitial() {
    this.homeService.GetAddMemberInitialModel({}).subscribe((brands:any) => {
      if (brands['Success']) {
        this.manipulateDataForDd(brands['Result'])
      }
    })
  }

  manipulateDataForDd(resultFromApi:any) {
    // transform the data from api to suit the ng prime dropdown i.e, {label:any,value:any}
    this.dropDownValues['CountryList'] = formatDataForDropDown(resultFromApi['CountryList'], 'CountryName', 'CountryId');
    this.dropDownValues['LocationList'] = formatDataForDropDown(resultFromApi['LocationList'], 'LocationName', 'LocationId');
  }

  AddCustomer(){
    //this.ngxService.start();
    // if(this.minDateError){
    //   this.detailForm.get('DateOfBirth').markAllAsTouched();
    // }
    // else{
      let addData = this.detailForm.value;
      this.homeService.AddCustomer(addData).subscribe((brands:any) => {
        if (brands['Success'] == true) {
          this.GetItemList(brands['Result']);
        }
        else{
          this.alertService.openDialog({ status: 'error', title: '', message: brands['Message'] });
        }
      })
    //}
  }

  GetItemList(result:any){
    this.homeService.GetItemList({CustomerId:result['CustomerId'],TransactionHeadId:result['TransactionHeadId']}).subscribe((brands:any) => {
      if (brands['Success']) {
        this.LocationName = brands['Result']['LocationName'];
        this.itemList = brands['Result']['ItemList'];
        this.TransactionHeadId = brands['Result']['TransactionHeadId'];
        //this.ngxService.stop();
      }
    })
  }

  itemSelect(itemDetail:any){
    const dialogRef = this.dialog.open(ItemStartdatePopupComponent,{
      width: '30rem',
      height: '24rem',
      data: {rowData: itemDetail}
    });
    dialogRef.afterClosed().subscribe((fromPopup)=>{
      if(fromPopup){
        console.log(fromPopup)

      let currentDate = new Date();
      this.itemDetail = itemDetail;
      let transactionData = {
        TransactionHeadId: this.TransactionHeadId,
        ItemClassificationName: this.itemDetail['ItemClassificationName'],
        ItemId: this.itemDetail['ItemId'],
        ItemDescription: this.itemDetail['ItemDescription'],
        Quanity: this.itemDetail['Quantity'],
        Price: this.itemDetail['Price'],
        ItemStartDate: fromPopup['ItemStartDate'],
        IsTaxable: this.itemDetail['IsTaxable']
      }
      this.homeService.AddTransactionItem(transactionData).subscribe((brands:any) => {
        if (brands['Success']) {
          //this.ngxService.stop();
          this.Amount = brands['Result']['AmountPayable'];
          this.stepper.next();
        }
      });
      }
    });
  }

  payNow(){
    let transaction = {
      TransactionHeadId: this.TransactionHeadId,
      ModeOfPaymentId: null,
      Amount: this.Amount
    }
    this.homeService.AddTransactionPaymentOnline(transaction).subscribe((brands:any) => {
      if (brands['Success']) {
        let queryData = {
          transId: this.TransactionHeadId,
          merchantOrderNo: brands['Result']['TransactionOrderNo']
        }
        this.router.navigate(['/','app-online-payment-adyen'],{relativeTo:this.aRoute,queryParams:queryData});
      }
    });
  }

  goToTerms(){
    //this.router.navigate(['/', 'terms-condition']);
    const dialogRef = this.dialog.open(TermsConditionComponent,{
      width: '80vw',
      height: '80vh',
      data: {
        transId: this.TransactionHeadId
      }
    });
    dialogRef.afterClosed().subscribe((fromPopup)=>{
      if(fromPopup){

      }
    });
  }

  onDateChange(event: MatDatepickerInputEvent<Date>): void{
    console.log('Teste', event.value);
    this.GetAge(event.value)
  }

  GetAge(birthDate) {
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    //return age;
    console.log(age);
    if(age < this.minAge){
      this.minDateError = true;
    }
    else{
      this.minDateError = false;
    }
  }

}

